// extracted by mini-css-extract-plugin
export default {"root":"rTEy3aSUiX4KOHrgWcqc","editable":"SxQvOhUkSIHrhadCSiS1","image":"sfuLhwd1yejDnZAXlnIX","remove":"m5htfbmkmGuo3cyDJMwS"};